import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import {ActivatedRoute, Router, ActivatedRouteSnapshot, NavigationError, NavigationStart} from '@angular/router';
import {newsDetales} from './newsDetales';
import * as $ from 'jquery';
import {Location} from '@angular/common';
import 'rxjs/add/operator/catch';
import {Globals} from '../globals';
import {NgxImageGalleryComponent, GALLERY_IMAGE, GALLERY_CONF} from 'ngx-image-gallery';
import {Meta, Title} from '@angular/platform-browser';
import {FacebookService} from '../facebook.service';

@Component({
  selector: 'app-news-detales',
  templateUrl: './news-detales.component.html',
  styleUrls: ['./news-detales.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewsDetalesComponent implements OnInit {
  newsDetales: newsDetales;
  url;
  urlshare;
  newsDetalesFalse;
  posts;
  curent;
  @ViewChild(NgxImageGalleryComponent) ngxImageGallery: NgxImageGalleryComponent;

  // gallery configuration
  conf: GALLERY_CONF = {
    imageOffset: '0px',
    showDeleteControl: false,
    showImageTitle: false,
    showThumbnails: false
  };
  config2: any = {
    effect: 'fade',
    autoplay: true, // Autoplay option having value in milliseconds
    initialSlide: 0, // Slide Index Starting from 0
    slidesPerView: 1, // Slides Visible in Single View Default is 1
    spaceBetween: 50,
    paginationClickable: true, // Making pagination dots clicable
    // pagination: '.swiper-pagination', // Pagination Class defined
    breakpoints: {
      900: {
        slidesPerView: 1,
      },
      640: {
        slidesPerView: 1,
      }
    },

    speed: 1000,
    loop: true,

    zoomToggle: false,
    setWrapperSize: true,

  };

  window: any = window;

  constructor(
    private http: HttpClient, public globals: Globals, private tittleService: Title, private meta: Meta, public facebookService: FacebookService,
    private route: ActivatedRoute, public _router: Router, public _location: Location
  ) {
    var url_string = location.href;
    this.urlshare = url_string;
    this.url = url_string;
    this.curent = url_string.substr(url_string.lastIndexOf('/') + 1);
    $(window).scrollTop(0);

    _router.events
      .subscribe((event: NavigationStart) => {

        if (event.navigationTrigger === 'popstate') {
          this.locationReload();
        }
      });

  }

  encodeURIComponent(val) {
    return encodeURIComponent(val);
  }

  locationReload(): void {

    setTimeout(() => {
      this._router.navigateByUrl('', {skipLocationChange: true}).then(() => {
        console.log(decodeURI(this._location.path()));
        this._router.navigate([decodeURI(this._location.path())]);
      });
    }, 200);
  }

  lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'hy';

  ngOnInit() {

    this.facebookService.loadSdk();
    this.facebookService.reinitializeLikeButton();
    this.imageWithoutsHref();
// console.log(this.urlshare)
    $('.slider.inline ').removeClass('active');
    this.captionOpen();
    $('body').delegate('#myModal span.close', 'click', function () {

      $('#myModal').slideUp();
    });
    this.image();
    $(window).scrollTop(0);

    this.http.get<newsDetales>(this.globals.urlMain + 'lrahos/' + this.curent).subscribe(data => {

      this.newsDetales = data;
      const detail = this.newsDetales.data.news.data;
      if (!detail.title && !detail.content) {
        detail.title = this.newsDetales.data.news.not_found;
        detail.date = '';
        detail.galery = [];
        detail.xoragir = [];
        this.newsDetales.data.sidebar.jomag = undefined;
      }

      this.meta.updateTag({property: 'og:url', content: this.urlshare});
      this.meta.updateTag({property: 'og:title', content: this.newsDetales.data.news.data.content});

      this.meta.updateTag({property: 'og:description', content: this.newsDetales.data.news.data.content});
      this.meta.updateTag({name: 'og:image', content: this.newsDetales.data.news.data.images});
      //   data.data.news.data.galery.forEach((picture, index) => {
      //     this.sliderLast.push(data.data.news.data.galery[index])
      //  });

    }, error => {
      this.newsDetalesFalse = true;
    });

  }

// images: GALLERY_IMAGE[] =
// newsDetales.data.news.data.galery.forEach(function (value) {
//   console.log(value);
// });


  openGallery(index: number = 0) {
    this.ngxImageGallery.open(index);
  }

  // close gallery
  closeGallery() {
    this.ngxImageGallery.close();
  }

  // set new active(visible) image in gallery
  newImage(index: number = 0) {
    this.ngxImageGallery.setActiveImage(index);
  }

  // next image in gallery
  nextImage(index: number = 0) {
    this.ngxImageGallery.next();
  }

  // prev image in gallery
  prevImage(index: number = 0) {
    this.ngxImageGallery.prev();
  }

  // EVENTS
  // callback on gallery opened
  galleryOpened(index) {
    console.info('Gallery opened at index ', index);
  }

  // callback on gallery closed
  galleryClosed() {
    console.info('Gallery closed.');
  }

  // callback on gallery image clicked
  galleryImageClicked(index) {
    console.info('Gallery image clicked with index ', index);
  }

  // callback on gallery image changed
  galleryImageChanged(index) {
    console.info('Gallery image changed to index ', index);
  }

  // callback on user clicked delete button
  deleteImage(index) {
    console.info('Delete image at index ', index);
  }

  imageWithoutsHref() {

    $('body').delegate('.newsDetalesPart p img ', 'click', function (e) {

      $('#myModal').slideDown(' ');

      var src = $(this).attr('src');

      e.preventDefault();
      $('#img01').attr('src', src);
    });


  }

  image() {
    $(window).scrollTop(0);
    $('body').delegate('.newsDetalesPart #contentee a img', 'click', function (e) {

      $('#myModal').slideDown('');
      var src = $(this).closest('a').attr('href');
      console.log(src);
      e.preventDefault();
      $('#img01').attr('src', src);
    });
    // $('.myImg').on('click', function() {
    //   console.log($(this).attr("src"));
    //   $('#myModal').show() ;
    //   $("#img01").attr('src' , $(this).attr("src"));

    // })

    // // Get the <span> element that closes the modal
    // var span =$(".close")[0];

    // When the user clicks on <span> (x), close the modal

  }

  openImage() {

    $('body').delegate('.newsDetalesPart .gallery img', 'click', function (e) {

      $('#myModal').slideDown('');
      if ($(this).attr('data-url')) {
        $('#img01').attr('src', $(this).attr('data-url'));
      } else {
        $('#img01').attr('src', $(this).attr('src'));
      }

    });


    // $('.myImg').on('click', function() {
    //   console.log($(this).attr("src"));
    //   $('#myModal').show() ;
    //   $("#img01").attr('src' , $(this).attr("src"));

    // })

    // // Get the <span> element that closes the modal
    // var span =$(".close")[0];

    // When the user clicks on <span> (x), close the modal
    $('span.close').on('click', function () {
      $('#myModal').hide();
    });
  }

  openImageglx() {

    $('body').delegate('.newsDetalesPart > img', 'click', function (e) {

      $('#myModal').slideDown('');

      $('#img01').attr('src', $(this).attr('data-url'));
    });

  }

  captionOpen() {

    $('body').delegate('figure', 'click', function (e) {

      $('#myModal').slideDown('');
      if ($(this).find('img').attr('alt')) {
        $('#img01').attr('src', $(this).find('img').attr('alt'));
      } else {
        $('#img01').attr('src', $(this).find('img').attr('src'));
      }

      $('#paragraph').html($(this).find('figcaption').html());
    });
    // $('.myImg').on('click', function() {
    //   console.log($(this).attr("src"));
    //   $('#myModal').show() ;
    //   $("#img01").attr('src' , $(this).attr("src"));

    // })

    // // Get the <span> element that closes the modal
    // var span =$(".close")[0];

    // When the user clicks on <span> (x), close the modal

  }
}
